import React, {ReactNode} from 'react';

import {FlexWrapper, Wrapper} from './styled';

interface Props {
    flex?: boolean;
    children: ReactNode;
}

export function Content({children, flex = false}: Props) {
    return flex ? <FlexWrapper>{children}</FlexWrapper> : <Wrapper>{children}</Wrapper>;
}
